import React from "react";

export default function BoostHero({ hero }) {
  if (!hero) return null;

  return (
    <div className="hero">
      <div className="heroLeft">
        <h1 className="heroTitle">{hero.title}</h1>
        <p className="heroDesc">{hero.description}</p>

        {(hero.actions || []).length ? (
          <div className="bi-heroActions">
            {(hero.actions || []).map((a) => (
              <a
                key={a.href}
                className={`bi-btn ${a.variant === "solid" ? "is-solid" : "is-outline"}`}
                href={a.href}
                target="_blank"
                rel="noreferrer"
              >
                {a.label}
              </a>
            ))}
          </div>
        ) : null}

        <div className="heroRight" aria-hidden="true">
          <div
            className="heroArt"
            style={{ backgroundImage: `url(${hero.heroImage})` }}
            role="img"
            aria-label={hero.heroImageAlt || "Hero art"}
          />
        </div>
      </div>

      <div className="hero-patterns" aria-hidden="true">
        <img src="/assets/img/banner.png" alt="" className="hero-pattern-image" />
      </div>
    </div>
  );
}
